import { createStyles } from '@mantine/core';

export const useOrderStyle = createStyles((theme) => ({
  item: {
    transition: 'transform 150ms ease',

    '&[data-active]': {
      backgroundColor: 'transparent',
      borderRadius: theme.radius.md,
      zIndex: 1,
    },
  },
  label: {
    padding: '5px 0px 7px 0px',
    color: '#D61D4F',
    fontSize: '11px',
    fontWeight: 450,
  },
  content: {
    padding: '0px 0px 10px 0px',
  },
  chevron: {
    color: '#FA9418',
    width: 'fit-content',
    minWidth: 'fit-content',
  },
  title: {
    color: '#D61D4F',
    fontWeight: 500,
  },
  input: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#7E7E7E',
    padding: '15px',
    borderColor: '#7E7E7E',
  },
  'input:: placeholder': {
    fontSize: '12px',
    color: '#7E7E7E',
  },
  close: {
    color: '#FF8C22',
  },
  radioOption: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  buttonSticky: {
    position: 'sticky',
    top: 0,
    bottom: 0,
  },
  root: {
    paddingTop: '8px !important',
  },
}));

export const useWebOrderStyle = createStyles((theme) => ({
  item: {
    transition: 'transform 150ms ease',

    '&[data-active]': {
      backgroundColor: 'transparent',
      borderRadius: theme.radius.md,
      zIndex: 1,
    },
  },
  label: {
    padding: '5px 0px 7px 0px',
    color: '#D61D4F',
    fontSize: '14px',
  },
  content: {
    padding: '0px 0px 10px 0px',
  },
  chevron: {
    color: '#FA9418',
  },
  title: {
    color: '#D61D4F',
  },
  input: {
    fontSize: '14px',
    borderColor: '#7E7E7E',
  },
  close: {
    color: '#FF8C22',
  },

  radioOption: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const useRadiorStyle = createStyles((theme) => ({
  label: {
    color: '#D61D4F',
    fontSize: '12px',
    paddingTop: '10px',
  },

  radioOption: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const singleRadioButton = createStyles((theme) => ({
  radio: {
    border: '0.0625rem solid #FA9418',
  },
  icon: {
    color: theme.colors.orange[6],
  },
}));

export const useWebRadiorStyle = createStyles((theme) => ({
  label: {
    color: '#D61D4F',
    fontSize: '14px',
    paddingTop: '10px',
  },

  radioOption: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const starRating = createStyles((theme) => ({
  'symbolBody svg': {
    stroke: 'yellow',
    fill: 'white',
  },
  text: {
    fontWeight: 500,
  },
}));
